import litigationImg from "../../../assets/images/service/court.jpeg";
import {
  Gavel,
  ShieldAlert,
  FileWarning,
  Scale,
  Landmark,
  FileCheck,
  TrendingUp,
  Maximize,
  UserCheck,
  
  
} from "lucide-react";
import ServiceSidebar from "../sidebar";

export default function ElectricalLitigation() {
  return (
    <>
      <section className="service-detail py-10">
        <div className="container">
          <div className="service-detail-inner">
            {/* Feature Section */}
            <div className="service-feature mb-8">
              <div className="row align-items-center gy-5">
                {/* Content */}
                <div className="col-lg-6 px-8 feature-content">
                  <h2 className="fw-bold mb-2">
                    Court Proceedings for <span className="green">Electrical Matters</span>
                  </h2>
                  <p className="mb-4">
                    Denial Enterprise provides expert legal representation and technical
                    testimony for disputes involving electricity theft allegations, billing
                    errors, and regulatory non-compliance in various judicial forums.
                  </p>

                  <div className="feature-points">
                    <div className="point">
                      <i className="fa fa-check-circle"></i>
                      <span>Representation in Special Electricity Courts & APTEL</span>
                    </div>
                    <div className="point">
                      <i className="fa fa-check-circle"></i>
                      <span>Technical defense for Section 135 & 126 (Electricity Act)</span>
                    </div>
                    <div className="point">
                      <i className="fa fa-check-circle"></i>
                      <span>Handling Consumer Forum cases for billing discrepancies</span>
                    </div>
                  </div>
                </div>
                {/* Image */}
                <div className="col-lg-6">
                  <div className="feature-image position-relative">
                    <img
                      src={litigationImg}
                      alt="Electrical Court Proceedings"
                      className="w-100 rounded2 shadow"
                    />
                    <div className="image-badge">
                      <i className="fa fa-balance-scale"></i> Expert Legal Defense
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Service Info */}
            <div className="service-info">
              <div className="row mt-6 gx-lg-5 gy-5">
                <div className="col-lg-4">
                  <ServiceSidebar />
                </div>
                {/* Left Content */}
                <div className="col-lg-8">
                  <div className="about-service mb-6">
                    <h3 className="mb-2">Defending Your Power Rights</h3>
                    <p className="mb-3">
                      Legal disputes in the power sector often involve complex technical evidence. We combine legal expertise with engineering insights to defend against arbitrary assessments or penalties levied by utility companies. From the initial reply to a show-cause notice to representation in High Courts, we ensure your case is grounded in both law and technical fact.
                    </p>
                    <p className="mb-3">
                      Our team is particularly experienced in navigating the **Electricity Act, 2003**, managing cases related to unauthorized use of electricity, meter tampering allegations, and Right of Way (RoW) disputes for transmission lines.
                    </p>

                    <ul className="icon-list-modern icon-list list-unstyled">
                      <li>
                        <span className="icon-wrap">
                          <Gavel size={22} />
                        </span>
                        <span>Defense against Assessment & Penalty Notices</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <ShieldAlert size={22} />
                        </span>
                        <span>Compounding of Offenses & Technical Audits</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <FileWarning size={22} />
                        </span>
                        <span>Stay Orders & Writ Petitions for Power Restoration</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Scale size={22} />
                        </span>
                        <span>Representation in Lok Adalats & Arbitrations</span>
                      </li>
                    </ul>
                  </div>

                  {/* Benefits */}
                  <div className="service-benefit">
                    <h4 className="mb-3">Why Technical Advocacy Matters</h4>
                    <p className="mb-6">
                      Electricity matters are won on technicalities. We leverage our engineering background to find discrepancies in utility reports, significantly reducing financial liabilities for our clients.
                    </p>
                    <ul className="icon-list-modern benefit-list">
                      <li>
                        <span className="icon-wrap">
                          <Scale size={22} />
                        </span>
                        <span>Accurate interpretation of technical meter data</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Landmark size={22} />
                        </span>
                        <span>Strong representation in Special Electricity Courts</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <FileCheck size={22} />
                        </span>
                        <span>Successful resolution of prolonged billing disputes</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <TrendingUp size={22} />
                        </span>
                        <span>Mitigation of reputation risk for corporate clients</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Maximize size={22} />
                        </span>
                        <span>Comprehensive support for RoW and Land disputes</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <UserCheck size={22} />
                        </span>
                        <span>Expert witness and technical advisory services</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}